export function ConvertToCustomDashboardDetail(customDashboardTemplateDetail: any) {
  const customDashboardDetail = {
    id: customDashboardTemplateDetail.id,
    number: customDashboardTemplateDetail.number,
    name: customDashboardTemplateDetail.name,
    customDashboardType: customDashboardTemplateDetail.customDashboardType,
    description: customDashboardTemplateDetail.description,
    imageUrl: customDashboardTemplateDetail.imageUrl,
    lastCalculateDateTime: customDashboardTemplateDetail.lastCalculateDateTime,
    isDeleted: customDashboardTemplateDetail.isDeleted,
    customDashboardGroup: null as any,
  };
  if (customDashboardTemplateDetail.customDashboardGroup) {
    const customDashboardGroup = customDashboardTemplateDetail.customDashboardGroup;
    customDashboardDetail.customDashboardGroup = {
      allocationId: customDashboardGroup.allocationId,
      allocationItemGroupList: customDashboardGroup.allocationItemGroupList,
    };
  }

  return customDashboardDetail;
}

export function ConvertToCustomDashboardList(_customDashboardList: any) {
  const customDashboardList: any = [];

  if (_customDashboardList && _customDashboardList.length > 0) {
    _customDashboardList.forEach((customDashboard: any) => {
      const customDashboardModel = {
        id: customDashboard.id,
        number: customDashboard.number,
        customDashboardType: customDashboard.customDashboardType,
        name: customDashboard.name,
        description: customDashboard.description,
        imageUrl: customDashboard.imageUrl
          ? process.env.VUE_APP_PeakBlobStorage + "peakengine" + customDashboard.imageUrl
          : "",
      };
      customDashboardList.push(customDashboardModel);
    });
  }

  return customDashboardList;
}

function ConvertToCustomDashboardGroup(_customDashboardGroup: any) {
  const customDashboardGroup = {
    createdUserId: _customDashboardGroup.createdUserId,
    customDashboardId: _customDashboardGroup.customDashboardId,
    allocationId: _customDashboardGroup.allocationId,
    allocationItemGroupList: [] as any,
  };

  if (_customDashboardGroup.allocationItemGroupList && _customDashboardGroup.allocationItemGroupList.length > 0) {
    _customDashboardGroup.allocationItemGroupList.forEach((item: any) => {
      customDashboardGroup.allocationItemGroupList.push(item);
    });
  }

  return customDashboardGroup;
}

function ConvertToSummaryDetailModel(_allocationSummaryDetail: any) {
  let allocationSummaryDetail = {
    revenueSummaryTotal: 0,
    expenseSummaryTotal: 0,
    profitSummaryTotal: 0,
    changeFormType: 0,
    revenueSummaryChangeValue: 0,
    expenseSummaryChangeValue: 0,
    profitSummaryChangeValue: 0,
    allocationSummaryItemDetailList: [] as any,
  };
  if (_allocationSummaryDetail) {
    allocationSummaryDetail = {
      revenueSummaryTotal: _allocationSummaryDetail.revenueSummaryTotal,
      expenseSummaryTotal: _allocationSummaryDetail.expenseSummaryTotal,
      profitSummaryTotal: _allocationSummaryDetail.profitSummaryTotal,
      changeFormType: _allocationSummaryDetail.changeFormType,
      revenueSummaryChangeValue: _allocationSummaryDetail.revenueSummaryChangeValue,
      expenseSummaryChangeValue: _allocationSummaryDetail.expenseSummaryChangeValue,
      profitSummaryChangeValue: _allocationSummaryDetail.profitSummaryChangeValue,
      allocationSummaryItemDetailList: [] as any,
    };

    if (
      _allocationSummaryDetail.allocationSummaryItemDetailList &&
      _allocationSummaryDetail.allocationSummaryItemDetailList.length > 0
    ) {
      _allocationSummaryDetail.allocationSummaryItemDetailList.forEach((item: any) => {
        allocationSummaryDetail.allocationSummaryItemDetailList.push(item);
      });
    }
  }

  return allocationSummaryDetail;
}

function ConvertToProfitLossDetailModel(_profitLossDetail: any) {
  let profitLossDetail = {
    revenueTotal: 0,
    costOfSalesAndServicesTotal: 0,
    grossProfitLossTotal: 0,
    sellingExpensesTotal: 0,
    administrativeExpenseTotal: 0,
    otherExpensesTotal: 0,
    netOperatingProfitLossBeforeInterestAndTaxTotal: 0,
    interestExpenseTotal: 0,
    incomeTaxTotal: 0,
    profitTotal: 0,
    allocationAccountList: [] as any,
  };
  if (_profitLossDetail) {
    profitLossDetail = {
      revenueTotal: _profitLossDetail.revenueTotal,
      costOfSalesAndServicesTotal: _profitLossDetail.costOfSalesAndServicesTotal,
      grossProfitLossTotal: _profitLossDetail.grossProfitLossTotal,
      sellingExpensesTotal: _profitLossDetail.sellingExpensesTotal,
      administrativeExpenseTotal: _profitLossDetail.administrativeExpenseTotal,
      otherExpensesTotal: _profitLossDetail.otherExpensesTotal,
      netOperatingProfitLossBeforeInterestAndTaxTotal:
        _profitLossDetail.netOperatingProfitLossBeforeInterestAndTaxTotal,
      interestExpenseTotal: _profitLossDetail.interestExpenseTotal,
      incomeTaxTotal: _profitLossDetail.incomeTaxTotal,
      profitTotal: _profitLossDetail.profitTotal,
      allocationAccountList: [] as any,
    };

    if (_profitLossDetail.allocationAccountList && _profitLossDetail.allocationAccountList.length > 0) {
      _profitLossDetail.allocationAccountList.forEach((item: any) => {
        profitLossDetail.allocationAccountList.push(item);
      });
    }
  }

  return profitLossDetail;
}

function ConvertToRevenueSummaryModel(_revenueSummary: any) {
  let revenueSummary = {
    total: 0,
    changeVaue: 0,
    changeFormType: 0,
    productTop1Id: 0,
    productTop2Id: 0,
    productTop3Id: 0,
    productTop1Total: 0,
    productTop2Total: 0,
    productTop3Total: 0,
    productOtherTotal: 0,
    productTop1ChangeValue: 0,
    productTop2ChangeValue: 0,
    productTop3ChangeValue: 0,
    contactTop1Total: 0,
    contactTop2Total: 0,
    contactTop3Total: 0,
    contactTop1Id: 0,
    contactTop2Id: 0,
    contactTop3Id: 0,
    contactOtherTotal: 0,
    contactTop1ChangeValue: 0,
    contactTop2ChangeValue: 0,
    contactTop3ChangeValue: 0,
    accountTop1Id: 0,
    accountTop2Id: 0,
    accountTop3Id: 0,
    accountTop1Total: 0,
    accountTop2Total: 0,
    accountTop3Total: 0,
    accountOtherTotal: 0,
    accountTop1ChangeValue: 0,
    accountTop2ChangeValue: 0,
    accountTop3ChangeValue: 0,
  };
  if (_revenueSummary) {
    revenueSummary = {
      total: _revenueSummary.total,
      changeVaue: _revenueSummary.changeVaue,
      changeFormType: _revenueSummary.changeFormType,
      productTop1Id: _revenueSummary.productTop1Id,
      productTop2Id: _revenueSummary.productTop2Id,
      productTop3Id: _revenueSummary.productTop3Id,
      productTop1Total: _revenueSummary.productTop1Total,
      productTop2Total: _revenueSummary.productTop2Total,
      productTop3Total: _revenueSummary.productTop3Total,
      productOtherTotal: _revenueSummary.productOtherTotal,
      productTop1ChangeValue: _revenueSummary.productTop1ChangeValue,
      productTop2ChangeValue: _revenueSummary.productTop2ChangeValue,
      productTop3ChangeValue: _revenueSummary.productTop3ChangeValue,
      contactTop1Total: _revenueSummary.contactTop1Total,
      contactTop2Total: _revenueSummary.contactTop2Total,
      contactTop3Total: _revenueSummary.contactTop3Total,
      contactTop1Id: _revenueSummary.contactTop1Id,
      contactTop2Id: _revenueSummary.contactTop2Id,
      contactTop3Id: _revenueSummary.contactTop3Id,
      contactOtherTotal: _revenueSummary.contactOtherTotal,
      contactTop1ChangeValue: _revenueSummary.contactTop1ChangeValue,
      contactTop2ChangeValue: _revenueSummary.contactTop2ChangeValue,
      contactTop3ChangeValue: _revenueSummary.contactTop3ChangeValue,
      accountTop1Id: _revenueSummary.accountTop1Id,
      accountTop2Id: _revenueSummary.accountTop2Id,
      accountTop3Id: _revenueSummary.accountTop3Id,
      accountTop1Total: _revenueSummary.accountTop1Total,
      accountTop2Total: _revenueSummary.accountTop2Total,
      accountTop3Total: _revenueSummary.accountTop3Total,
      accountOtherTotal: _revenueSummary.accountOtherTotal,
      accountTop1ChangeValue: _revenueSummary.accountTop1ChangeValue,
      accountTop2ChangeValue: _revenueSummary.accountTop2ChangeValue,
      accountTop3ChangeValue: _revenueSummary.accountTop3ChangeValue,
    };
  }

  return revenueSummary;
}

function ConvertToExpenseSummaryModel(_expenseSummary: any) {
  let expenseSummary = {
    total: 0,
    changeVaue: 0,
    changeFormType: 0,
    productTop1Id: 0,
    productTop2Id: 0,
    productTop3Id: 0,
    productTop1Total: 0,
    productTop2Total: 0,
    productTop3Total: 0,
    productOtherTotal: 0,
    productTop1ChangeValue: 0,
    productTop2ChangeValue: 0,
    productTop3ChangeValue: 0,
    contactTop1Total: 0,
    contactTop2Total: 0,
    contactTop3Total: 0,
    contactTop1Id: 0,
    contactTop2Id: 0,
    contactTop3Id: 0,
    contactOtherTotal: 0,
    contactTop1ChangeValue: 0,
    contactTop2ChangeValue: 0,
    contactTop3ChangeValue: 0,
    accountTop1Id: 0,
    accountTop2Id: 0,
    accountTop3Id: 0,
    accountTop1Total: 0,
    accountTop2Total: 0,
    accountTop3Total: 0,
    accountOtherTotal: 0,
    accountTop1ChangeValue: 0,
    accountTop2ChangeValue: 0,
    accountTop3ChangeValue: 0,
    accountExpenseTypeTop1Id: 0,
    accountExpenseTypeTop2Id: 0,
    accountExpenseTypeTop3Id: 0,
    accountExpenseTypeTop1Total: 0,
    accountExpenseTypeTop2Total: 0,
    accountExpenseTypeTop3Total: 0,
    accountExpenseTypeOtherTotal: 0,
    accountExpenseTypeTop1ChangeValue: 0,
    accountExpenseTypeTop2ChangeValue: 0,
    accountExpenseTypeTop3ChangeValue: 0,
  };
  if (_expenseSummary) {
    expenseSummary = {
      total: _expenseSummary.total,
      changeVaue: _expenseSummary.changeVaue,
      changeFormType: _expenseSummary.changeFormType,
      productTop1Id: _expenseSummary.productTop1Id,
      productTop2Id: _expenseSummary.productTop2Id,
      productTop3Id: _expenseSummary.productTop3Id,
      productTop1Total: _expenseSummary.productTop1Total,
      productTop2Total: _expenseSummary.productTop2Total,
      productTop3Total: _expenseSummary.productTop3Total,
      productOtherTotal: _expenseSummary.productOtherTotal,
      productTop1ChangeValue: _expenseSummary.productTop1ChangeValue,
      productTop2ChangeValue: _expenseSummary.productTop2ChangeValue,
      productTop3ChangeValue: _expenseSummary.productTop3ChangeValue,
      contactTop1Total: _expenseSummary.contactTop1Total,
      contactTop2Total: _expenseSummary.contactTop2Total,
      contactTop3Total: _expenseSummary.contactTop3Total,
      contactTop1Id: _expenseSummary.contactTop1Id,
      contactTop2Id: _expenseSummary.contactTop2Id,
      contactTop3Id: _expenseSummary.contactTop3Id,
      contactOtherTotal: _expenseSummary.contactOtherTotal,
      contactTop1ChangeValue: _expenseSummary.contactTop1ChangeValue,
      contactTop2ChangeValue: _expenseSummary.contactTop2ChangeValue,
      contactTop3ChangeValue: _expenseSummary.contactTop3ChangeValue,
      accountTop1Id: _expenseSummary.accountTop1Id,
      accountTop2Id: _expenseSummary.accountTop2Id,
      accountTop3Id: _expenseSummary.accountTop3Id,
      accountTop1Total: _expenseSummary.accountTop1Total,
      accountTop2Total: _expenseSummary.accountTop2Total,
      accountTop3Total: _expenseSummary.accountTop3Total,
      accountOtherTotal: _expenseSummary.accountOtherTotal,
      accountTop1ChangeValue: _expenseSummary.accountTop1ChangeValue,
      accountTop2ChangeValue: _expenseSummary.accountTop2ChangeValue,
      accountTop3ChangeValue: _expenseSummary.accountTop3ChangeValue,
      accountExpenseTypeTop1Id: _expenseSummary.accountExpenseTypeTop1Id,
      accountExpenseTypeTop2Id: _expenseSummary.accountExpenseTypeTop2Id,
      accountExpenseTypeTop3Id: _expenseSummary.accountExpenseTypeTop3Id,
      accountExpenseTypeTop1Total: _expenseSummary.accountExpenseTypeTop1Total,
      accountExpenseTypeTop2Total: _expenseSummary.accountExpenseTypeTop2Total,
      accountExpenseTypeTop3Total: _expenseSummary.accountExpenseTypeTop3Total,
      accountExpenseTypeOtherTotal: _expenseSummary.accountExpenseTypeOtherTotal,
      accountExpenseTypeTop1ChangeValue: _expenseSummary.accountExpenseTypeTop1ChangeValue,
      accountExpenseTypeTop2ChangeValue: _expenseSummary.accountExpenseTypeTop2ChangeValue,
      accountExpenseTypeTop3ChangeValue: _expenseSummary.accountExpenseTypeTop3ChangeValue,
    };
  }

  return expenseSummary;
}

function ConvertToprofitLossListModel(_profitLossList: any) {
  const profitLossList: any = [];
  if (_profitLossList && _profitLossList.length > 0) {
    _profitLossList.forEach((_profitLoss: any) => {
      const profitLoss: any = ConvertToProfitLossDetailModel(_profitLoss);
      profitLoss.allocationItemGroup = _profitLoss.allocationItemGroup ? _profitLoss.allocationItemGroup : null;
      profitLossList.push(profitLoss);
    });
  }
  return profitLossList;
}

export function ConvertToAllocationDashBoardDetail(_allocationDashBoardDetail: any) {
  const allocationDashBoardDetail = {
    customDashBoardId: _allocationDashBoardDetail.customDashBoardId,
    allocationId: _allocationDashBoardDetail.allocationId,
    customDashboardGroup: _allocationDashBoardDetail.customDashboardGroup
      ? ConvertToCustomDashboardGroup(_allocationDashBoardDetail.customDashboardGroup)
      : null,
    dashboardSelectOptionType: _allocationDashBoardDetail.dashboardSelectOptionType,
    fromDate: _allocationDashBoardDetail.fromDate,
    toDate: _allocationDashBoardDetail.toDate,
    revenueSummaryTotal: _allocationDashBoardDetail.revenueSummaryTotal,
    expenseSummaryTotal: _allocationDashBoardDetail.expenseSummaryTotal,
    profitSummaryTotal: _allocationDashBoardDetail.profitSummaryTotal,
    summaryDetail: ConvertToSummaryDetailModel(_allocationDashBoardDetail.summaryDetail),
    profitLossDetail: ConvertToProfitLossDetailModel(_allocationDashBoardDetail.profitLossDetail),
    revenue: ConvertToRevenueSummaryModel(_allocationDashBoardDetail.revenue),
    expense: ConvertToExpenseSummaryModel(_allocationDashBoardDetail.expense),
  };
  return allocationDashBoardDetail;
}

export function ConvertToAllocationDashBoardCompare(_allocationDashBoardCompare: any) {
  const allocationDashBoardCompare = {
    customDashBoardId: _allocationDashBoardCompare.customDashBoardId,
    allocationId: _allocationDashBoardCompare.allocationId,
    customDashboardGroup: _allocationDashBoardCompare.customDashboardGroup
      ? ConvertToCustomDashboardGroup(_allocationDashBoardCompare.customDashboardGroup)
      : null,
    dashboardSelectOptionType: _allocationDashBoardCompare.dashboardSelectOptionType,
    fromDate: _allocationDashBoardCompare.fromDate,
    toDate: _allocationDashBoardCompare.toDate,
    profitLossList: ConvertToprofitLossListModel(_allocationDashBoardCompare.profitLossList),
    revenue: ConvertToRevenueSummaryModel(_allocationDashBoardCompare.revenue),
    expense: ConvertToExpenseSummaryModel(_allocationDashBoardCompare.expense),
  };

  return allocationDashBoardCompare;
}
